const flatbuffers = require('flatbuffers')
const ECGSmartTrainer = require('../../../mobile_ecg_generated').ECGSmartTrainer

export default function getSignal(arr) {
  let a = new Uint8Array(arr)
  let inputByteBuffer = new flatbuffers.ByteBuffer(a)
  let signal = ECGSmartTrainer.ECGDataPackage.getRootAsECGDataPackage(inputByteBuffer)
  return signal
}
